
import { h, JSX } from 'preact';
import ObservingComponent from '../../../componentBases/observingComponent';
import DayPassReportPageProps from './dayPassReportPageProps';
import { BoldReportsReportViewerPage, BoldReportsReportViewerPageOptions, DayPassReportPageActions } from 'core.frontend';
import Button from '../../../buttons/button';
import { BoldReportsViewer } from '../../../boldReportsViewer';
import 'preact/compat';

class DayPassReportPage extends ObservingComponent<DayPassReportPageProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.page.observationProvider, DayPassReportPageActions.BoldReportsViewerLoaded);
    }


    public render({ page }: DayPassReportPageProps): JSX.Element {
        const { api, currentUserManager, reportOptions } = page;

        const options: BoldReportsReportViewerPageOptions = {
            reportId: 'DayPassReport.rdl',
            reportParams: [
                { name: 'EventId', values: [String(reportOptions.eventId)] },
                { name: 'EventAttendeeIds', values: reportOptions.eventAttendeeIds.map(String) },
                { name: 'IncludePhotos', values: [String(reportOptions.includePhotos)] },
                { name: 'LineOfBusinessId', values: [String(reportOptions.lineOfBusinessId)] }
            ]
        };

        const reportViewerPage = new BoldReportsReportViewerPage(api, currentUserManager, options);

        return (
            <div class="report">
                <div class="flex">
                    <Button
                        className="mr-auto btn-icon"
                        button={page.backButton} />
                </div>
                <div>
                    <BoldReportsViewer page={reportViewerPage}></BoldReportsViewer>
                </div>
            </div>
        );
    }
}

export default DayPassReportPage;
